import { defineMessages } from 'react-intl';

export default defineMessages({
  oligoName: {
    id: 'oligoName',
    defaultMessage: 'Oligo name'
  },
  oligoNameRequired: {
    id: 'oligoNameRequired',
    defaultMessage: 'Oligo name is required.'
  },
  researcherName: {
    id: 'researcherName',
    defaultMessage: 'Researcher name'
  },
  researcherNameRequired: {
    id: 'researcherNameRequired',
    defaultMessage: 'Researcher name is required.'
  },
  researcherNameMaxLengthError: {
    id: 'researcherNameMaxLengthError',
    defaultMessage: 'Researcher name should be less than or equal to 30 characters.'
  },
  oligoNameMaxLengthError: {
    id: 'oligoNameMaxLengthError',
    defaultMessage: 'Oligo name should be less than or equal to 30 characters.'
  },
  researcherNameStartsWithSpaceError: {
    id: 'researcherNameStartsWithSpaceError',
    defaultMessage: 'Researcher name should not be starting with an empty space.'
  },
  oligoNameStartsWithSpaceError: {
    id: 'oligoNameStartsWithSpaceError',
    defaultMessage: 'Oligo name should not be starting with an empty space.'
  },
  typesOfRNA: {
    id: 'typesOfRNA',
    defaultMessage: 'Types of RNA'
  },
  siRna: {
    id: 'siRNA',
    defaultMessage: 'single strand RNA',
  },
  stealthRNAi: {
    id: 'stealthRNAi',
    defaultMessage: 'Stealth RNAi',
  },
  senseSequence: {
    id: 'senseSequence',
    defaultMessage: 'Sense sequence',
  },
  senseSequenceRequired: {
    id: 'senseSequenceRequired',
    defaultMessage: 'Sense sequence is required',
  },
  senseModification: {
    id: 'senseModification',
    defaultMessage: 'Sense 5\' modification',
  },
  antisenseSequence: {
    id: 'ntisenseSequence',
    defaultMessage: 'Antisense sequence (5\' to 3\')',
  },
  antisenseSequenceRequired: {
    id: 'antisenseSequenceRequired',
    defaultMessage: 'Antisense sequence is required',
  },
  antisenseModification: {
    id: 'antisenseModification',
    defaultMessage: 'Antisense 5\' modification',
  },
  biotin: {
    id: 'biotin',
    defaultMessage: 'Biotin',
  },
  fluorescein: {
    id: 'fluorescein',
    defaultMessage: 'Fluorescein'
  },
  phosphate: {
    id: 'phosphate',
    defaultMessage: 'Phosphate',
  },
  overhang: {
    id: 'overhang',
    defaultMessage: '3\' overhang',
  },
  dTdT: {
    id: 'dTdT',
    defaultMessage: 'dTdT',
  },
  scale: {
    id: 'scale',
    defaultMessage: 'Scale',
  },
  nmole20: {
    id: 'nmole20',
    defaultMessage: '20 nmole',
  },
  nmole80: {
    id: 'nmole80',
    defaultMessage: '80 nmole',
  },
  umole1: {
    id: 'umole1',
    defaultMessage: '1 umole',
  },
  umole1p7: {
    id: 'umole1p7',
    defaultMessage: '1.7 umole',
  },
  purity: {
    id: 'purity',
    defaultMessage: 'Purity',
  },
  desalted: {
    id: 'desalted',
    defaultMessage: 'Desalted',
  },
  baseCount: {
    id: 'baseCount',
    defaultMessage: 'Base count: {count}',
  },
  duplex: {
    id: 'duplex',
    defaultMessage: 'Duplex',
  },
  sequenceError: {
    id: 'sequenceError',
    defaultMessage: 'Invalid base. Valid bases for RNA include: ACGU.',
  },
  seseSequenceFixedLengthError: {
    id: 'seseSequenceFixedLengthError',
    defaultMessage: 'Sense Sequence - Number of bases must be equal to {length}.',
  },
  seseSequenceIntervalLengthError: {
    id: 'seseSequenceIntervalLengthError',
    defaultMessage: 'Sense Sequence - Number of bases must be within {min} and {max}.',
  },
  nameValidation: {
    id: 'nameValidation',
    defaultMessage: 'Name should only include numbers, letters, underscores, hyphens, or periods.'
  },
  failedAddToCart: {
    id: 'failedAddToCart',
    defaultMessage: 'Failed adding your changes to cart. Please try again.'
  },
  addToCart: {
    id: 'addToCart',
    defaultMessage: 'Add to cart'
  },
});
